/** @format */
import posthog from "posthog-js";

export function trackEvent(event: string, properties?: Record<string, unknown>) {
  // Defer PostHog processing so UI interactions (navigate, state changes) aren't blocked.
  // posthog.capture() does synchronous property enrichment and queue management
  // that can block the main thread during critical interaction paths.
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(() => posthog.capture(event, properties), {
      timeout: 3000,
    });
  } else {
    setTimeout(() => posthog.capture(event, properties), 0);
  }
}
